module.exports = __webpack_public_path__ + "static/media/Jawbreak-Sans.9e8134fc.svg";